import request from "src/api/request-manager/gateway";

import type { BeneficiaryBanksGroupsResponse, SenderBanksGroupsResponse } from "src/api/interfaces/general";

import type { SetDefaultCompanyData, SwitchAccountData } from "./types/general.types";

const prefixURL = "/ffb-disbursement/api/v1";
const onboardingPrefixURL = "/dashboard/v1";

const GeneralAPI = {
  // Existing disbursement endpoints
  getSenderBanksGroups() {
    return request.get<SenderBanksGroupsResponse>(`${prefixURL}/general/sender-banks-groups`);
  },
  getBeneficiayBanksGroups() {
    return request.get<BeneficiaryBanksGroupsResponse>(`${prefixURL}/general/beneficiary-banks-groups`);
  },

  // Onboarding migration endpoints
  switchAccount(data: SwitchAccountData) {
    return request.post(`${onboardingPrefixURL}/user/switch-account`, data);
  },
  setDefaultCompany(data: SetDefaultCompanyData) {
    return request.post(`${onboardingPrefixURL}/setting/default-company`, data);
  },
  getCityList() {
    return request.get(`${onboardingPrefixURL}/general/city-list`);
  },
  getGroupCityList() {
    return request.get(`${onboardingPrefixURL}/general/city-group-list`);
  },
  getProvinceList() {
    return request.get(`${onboardingPrefixURL}/general/province-list`);
  },
  getIndustryList() {
    return request.get(`${onboardingPrefixURL}/general/industry-list`);
  },
  getActionRules() {
    return request.get(`${onboardingPrefixURL}/general/actions-rule`);
  },
  getCountdownOtp(params: any) {
    return request.get(`${onboardingPrefixURL}/general/countdown-otp`, params);
  },
  getTransactionStatus() {
    return request.get(`${prefixURL}/general/transaction-status`);
  },
  getOperationalHours() {
    return request.get(`${prefixURL}/general/operational-hours`);
  }
};

const GeneralAPIPaths = {
  senderBanksGroups: `${prefixURL}/general/sender-banks-groups`,
  operationalHours: `${prefixURL}/general/operational-hours`,
  transactionStatus: `${prefixURL}/general/transaction-status`
};

export default { ...GeneralAPI, ...GeneralAPIPaths };
